import { render, staticRenderFns } from "./LinkMessage.vue?vue&type=template&id=193df98e"
import script from "./LinkMessage.vue?vue&type=script&lang=js"
export * from "./LinkMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports